import { buyNowQueryParamsSessionStorage } from './BuyNowQueryParamsSessionStorage';

const isBuyNowPath = () => typeof window !== 'undefined' && window.location.pathname.toLowerCase().includes('buynow');

// Capture URL params at module load (before React mounts) so params survive SSO redirects
// and URL cleanup that may run before redirect components mount.
export const INITIAL_BUYNOW_SEARCH_PARAMS =
  typeof window !== 'undefined' && isBuyNowPath() ? window.location.search : '';

if (INITIAL_BUYNOW_SEARCH_PARAMS) {
  buyNowQueryParamsSessionStorage.saveFromSearchParams(INITIAL_BUYNOW_SEARCH_PARAMS);
}
